<template>
  <section style="width: 400px; border: 1px solid #ccc; border-radius: 5px; margin: 40px auto 0 auto;">
    <form @submit.prevent="submit()">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">ログイン</p>
        </header>
        <section class="modal-card-body">
          <b-field label="メールアドレス">
            <b-input
              type="text"
              v-model="form.email"
            >
            </b-input>
          </b-field>

          <b-field label="パスワード">
            <b-input
              type="password"
              v-model="form.password"
              password-reveal
            >
            </b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary">ログイン</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    submit() {
      axios.post('/api/app/login', this.form).then(res => {
        localStorage.setItem("X-Token", res.data.token)
        this.$router.push('/app/surveys')
      }).catch(() => {
        window.alert('ログイン情報が一致していません。')
      })
    }
  }
}
</script>

<style scoped>
.form {
  width: 500px;
  margin: 0 auto;
  margin-top: 40px;
}
</style>
